import React, { useState } from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import Checkbox from "../../../common/Checkbox";
import { useTranslation } from "react-i18next";

const DocumentListing = ({
  checkList,
  handleChangeCheck,
  handleChangeCheckAll,
}) => {
  const { t } = useTranslation();

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>
              <Box display="flex" alignItems="center" marginBottom="10px">
                <Checkbox
                  checked={checkList.every((elem) => elem.selected)}
                  onChange={handleChangeCheckAll}
                  theme={"secondary"}
                />
                <Typography variant="p" marginTop="8px" fontWeight="bold">
                  {t("ready")}
                </Typography>
              </Box>
            </TableCell>
            <TableCell>{t("name-of-document")}</TableCell>
            <TableCell align="left">{t("relavent-features")}</TableCell>
            <TableCell align="left">{t("how-to-submit")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {checkList?.map((item) => {
            return (
              <TableRow>
                <TableCell component="th" scope="row">
                  <div
                    style={{
                      marginTop: "-8px",
                      display: "flex",
                      alignItems: "left",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Checkbox
                      id={item.userDocumentChecklistId}
                      checked={item.selected}
                      onChange={handleChangeCheck}
                      theme={"secondary"}
                    />
                  </div>
                </TableCell>
                <TableCell align="left">
                  {t(item?.documentNameKey) || ""}
                </TableCell>
                <TableCell sx={{ cursor: "pointer" }} align="left">
                  {t(item?.relevantFeatureKey) || ""}
                </TableCell>
                <TableCell align="left">
                  {t(item?.howToSubmitKey) || ""}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DocumentListing;
